/* eslint-disable no-throw-literal */
import { createAction } from 'redux-act';

import config from 'config';

import { card2cardApi, initializeAppApi } from '@api/index';
import { REQUEST_STATUS } from '@utils/constants';
import { LoadingStatuses, RegisterTransferRequest, RequestTypes } from '@utils/types';

export const moduleName = 'requests';
export const isProduction = config.get('client.env') === 'production';

export const setRequestLoading = createAction<object>(`${moduleName}/SET_REQUEST_LOADING`);
export const setResponseInitApp = createAction<object>(`${moduleName}/SET_RESPONSE_INIT_APP`);
export const setResponseRegisterTransfer = createAction<object>(`${moduleName}/SET_RESPONSE_REGISTER_TRANSFER`);

export const setLoading = (request: RequestTypes, loadingStatus: LoadingStatuses) => (dispatch) => {
    switch (loadingStatus) {
        case 'loading':
            return dispatch(setRequestLoading({ [request]: REQUEST_STATUS.LOADING }));
        case 'success':
            return dispatch(setRequestLoading({ [request]: REQUEST_STATUS.SUCCESS }));
        case 'failure':
            return dispatch(setRequestLoading({ [request]: REQUEST_STATUS.FAILURE }));
        default:
            return dispatch(setRequestLoading({ [request]: REQUEST_STATUS.DEFAULT }));
    }
};

/** Запрос инициализации приложения */
export const makeInitializeApplicationRequest = (publicId: string) => async (dispatch) => {
    try {
        dispatch(setLoading('initializeApplicationRequest', 'loading'));

        initializeAppApi
            .getTransferData({ publicId })
            .then((res: any) => {
                dispatch(setLoading('initializeApplicationRequest', 'success'));
                dispatch(setResponseInitApp(res.data));
            })
            .catch(() => {
                dispatch(setLoading('initializeApplicationRequest', 'success'));
                dispatch(setResponseInitApp({}));
            });
    } catch (error) {
        dispatch(setLoading('initializeApplicationRequest', 'failure'));

        throw error?.response;
    }
};

/** Отправка данных карты на мидл */
export const makeCardDataRequest = (cardData: RegisterTransferRequest, publicId: string) => async (dispatch) => {
    try {
        dispatch(setLoading('transferRequest', 'loading'));

        const { data }: any = await card2cardApi.registerTransfer({ cardData, publicId });

        dispatch(setLoading('transferRequest', 'success'));
        dispatch(setResponseRegisterTransfer(data));
    } catch (error) {
        dispatch(setLoading('transferRequest', 'failure'));

        throw error?.response;
    }
};
